export default __webpack_public_path__ + "static/media/12-2.a3142a3c.jpeg";